/* 🤖 this file was generated by svg-to-ts*/
export const icoUser: {
  name: 'user';
  data: string;
} = {
  name: 'user',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.333 13H6.667c-2.036 0-3.666 1.712-3.666 3.8L3 18.223l.315.297C5.683 20.745 8.748 22 12 22c3.252 0 6.317-1.255 8.685-3.48l.315-.297v-1.424C21 14.712 19.368 13 17.332 13zm0 2l.142.007c.845.077 1.524.841 1.524 1.793l.001.546-.197.17C16.882 19.112 14.507 20 12 20l-.341-.006c-2.38-.076-4.628-.953-6.462-2.479L5 17.346v-.545C5 15.795 5.759 15 6.668 15h10.666zM12 2a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z" fill="#909090"/></svg>`
};
